import { MapPin, Video, ExternalLink } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { Stagger, StaggerItem, FadeUp } from "@/components/Reveal";

export const ADDRESS = {
  place: "Metropolitan Office, 2008",
  street: "Estr. São Francisco, 2008 - Vila Sonia do Taboão",
  city: "Taboão da Serra - SP, 06764-290",
  note: "Ao lado do Shopping Taboão",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=Estr.+S%C3%A3o+Francisco,+2008+-+Vila+Sonia+do+Tabo%C3%A3o,+Tabo%C3%A3o+da+Serra+-+SP,+06764-290",
  mapsEmbed: "https://www.google.com/maps?q=Estr.+S%C3%A3o+Francisco,+2008+-+Vila+Sonia+do+Tabo%C3%A3o,+Tabo%C3%A3o+da+Serra+-+SP&output=embed",
};

const Modalidades = () => (
  <section data-testid="modalidades-section" className="py-20 lg:py-28">
    <div className="container-x">
      <SectionHeading eyebrow="04 — Onde" title="Presencial e online" testId="modalidades" />
      <Stagger className="mt-14 grid gap-6 md:grid-cols-2" gap={0.12}>
        <StaggerItem className="h-full">
          <article
            data-testid="modalidade-presencial"
            className="group h-full rounded-3xl border border-raiz-900/10 bg-cream p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-raiz-600/50 lg:p-12"
          >
            <MapPin aria-hidden="true" className="h-8 w-8 text-raiz-600 transition-transform duration-500 group-hover:-translate-y-1" />
            <h3 className="mt-8 font-serif text-2xl font-light text-ink lg:text-3xl">Presencial</h3>
            <p className="mt-4 text-sm leading-relaxed text-ink/65">
              Atendimento em ambiente clínico reservado e adequado, pensado para acolher cada pessoa com privacidade e conforto.
            </p>
            <address className="mt-6 text-sm not-italic leading-relaxed text-raiz-900" data-testid="presencial-endereco">
              <strong className="font-medium">{ADDRESS.place}</strong>
              <br />
              {ADDRESS.street}
              <br />
              {ADDRESS.city}
              <br />
              <span className="text-ink/50">{ADDRESS.note}</span>
            </address>
            <a
              href={ADDRESS.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="presencial-mapa-link"
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-raiz-800 underline decoration-raiz-300 underline-offset-4 transition-colors hover:text-raiz-600"
            >
              Ver no mapa
              <ExternalLink aria-hidden="true" className="h-3.5 w-3.5" />
            </a>
          </article>
        </StaggerItem>
        <StaggerItem className="h-full">
          <article
            data-testid="modalidade-online"
            className="group h-full rounded-3xl border border-raiz-900/10 bg-raiz-800 p-8 text-raiz-50 transition-all duration-500 hover:-translate-y-1.5 hover:bg-raiz-700 lg:p-12"
          >
            <Video aria-hidden="true" className="h-8 w-8 text-raiz-200 transition-transform duration-500 group-hover:-translate-y-1" />
            <h3 className="mt-8 font-serif text-2xl font-light lg:text-3xl">Online</h3>
            <p className="mt-4 text-sm leading-relaxed text-raiz-100/75">
              Atendimento psicológico por videochamada, observando as normas profissionais vigentes e a adequação da modalidade à demanda.
            </p>
            <p className="mt-6 text-xs uppercase tracking-[0.22em] text-raiz-100/45">De onde você estiver</p>
          </article>
        </StaggerItem>
      </Stagger>
      <FadeUp delay={0.15} className="mt-8">
        <div className="overflow-hidden rounded-3xl border border-raiz-900/10" data-testid="presencial-mapa-embed">
          <iframe
            src={ADDRESS.mapsEmbed}
            title="Mapa — Metropolitan Office, Estr. São Francisco, 2008, Taboão da Serra"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="h-72 w-full border-0 lg:h-96"
            allowFullScreen
          />
        </div>
      </FadeUp>
    </div>
  </section>
);

export default Modalidades;
